import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "./style.scss";

// images
import menuBg from "../../assets/images/bg/menu/home.svg";
import heroBg from "../../assets/images/bg/community1.jpg";

// components
import Header from "../../components/header";
import Plans from "../../components/insurancepricing/Plans";
import FooterBottom from "../../components/footerBottom";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";

import { Element } from "react-scroll";
import { getSingleInsurance, setIntendedUrl } from "../reduxinsurance/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";
import logo from "../../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

const SingleInsurance = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isLoading = useSelector((state) => state?.meta?.isLoading);

  const planSectionRef = useRef(null);

  const location = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (!isLoading && !!props?.insurance?.insurance?.plans && location.state === "insurence") {
        location.state = null;
      }
    }, 1500);
  }, [location]);

  const cookie = new Cookies();

  const dispatch = useDispatch();

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  const handleClickTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    if (!cookie.get("user_token")) {
      dispatch(setIntendedUrl(`/insurance/${props?.match?.params?.insurance_slug}`));
      props.history.push("/login");
    }

    handleClickTop();
    props.getSingleInsurance(props?.match?.params?.insurance_slug);
  }, [props?.match?.params?.insurance_slug]);

  useEffect(() => {
    if (props?.insurance?.insurance?.keyword?.length > 0) {
      const dataKeyword = props?.insurance?.insurance?.keyword;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.insurance?.insurance?.keyword]);

  return (
    <>
      <Helmet>
        <title>{props?.insurance?.insurance?.name || "Insurance"} - Clarity Cooperative</title>
        <meta name="description" content={props?.insurance?.insurance?.description} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={props?.insurance?.insurance?.name} />
        <meta property="og:url" content={props?.insurance?.insurance?.url} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.insurance?.insurance?.description} />
        <meta name="twitter:card" content={props?.insurance?.insurance?.description} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.insurance?.insurance?.url} />
        <meta name="twitter:title" content={props?.insurance?.insurance?.name} />
        <meta name="twitter:description" content={props?.insurance?.insurance?.description} />
        <meta name="twitter:image" content={logo} />
        <meta name="robots" content="noindex" />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleEmpty" blackLogo />{" "}
      <div className="section overflow-hidden position-relative">
        <Container className="position-relative zIndex-1">
          <Row className="align-items-center">
            <Col md={6}>
              <span className="fw-bold">{props?.insurance?.insurance?.hero_title_small}</span>
              <h1>{props?.insurance?.insurance?.name || ""}</h1>
              <p>{props?.insurance?.insurance?.description || ""}</p>
            </Col>
            {props?.insurance?.insurance?.image !== undefined && (
              <Col md={6}>
                <img className="img-fluid rounded-3" src={props?.insurance?.insurance?.image} alt="hero img" />
              </Col>
            )}
          </Row>
        </Container>
        <img className="position-absolute end-0 top-0 d-none d-xl-block" src={heroBg} alt="shape" />

        {/* <ScrollLink to="packages" spy={true} smooth={true} duration={500} className="scrollBtn">
          <img className="scrollText" src={scrollText} alt="text" />
          <img className="angleText" src={angleDown} alt="angle" />
        </ScrollLink> */}
      </div>
      <Element name="packages">
        {props.insurance?.insurance?.plans?.length !== 0 ? (
          <>
            <Plans plans={props?.insurance?.insurance?.plans} ref={planSectionRef} />
            <Container rclassName="my-4 text-muted">
              <p className="text-muted">
                <span className="fw-bold">Disclaimer</span> We hope you benefit from the partners we recommend. They were each selected and vetted by industry
                experts. In the spirit of reciprocity and cooperation, in exchange for providing exclusive discounts for our members, the Cooperative collects a
                share of sales and/or other compensation for any purchase using any of the links on this page. We hope you find the exclusive discounts helpful.
              </p>
            </Container>
          </>
        ) : null}
      </Element>
      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  insurance: state.insurancereducer.insurance,
});

export default connect(mapStateToProps, {
  getSingleInsurance,
})(SingleInsurance);
